module.exports = __webpack_public_path__ + "img/SHOPPING_BAG.2d48eed8.svg";